import React, { CSSProperties } from 'react';

type V2SpinnerProps = {
  size?: 'small' | 'default' | 'large';
  style?: CSSProperties;
  className?: string;
};

/**
 * Custom V2 Loading Spinner Icon
 * A theme-aware, animated loading indicator that can be used as a standalone icon
 * or as a custom indicator for AntD's Spin component.
 */
const V2Spinner: React.FC<V2SpinnerProps> = ({ size = 'default', style, className }) => {
  const primaryColor = '#06988F';
  const secondaryColor = '#0BBBAF';

  // Size mapping
  const sizeMap = {
    small: '16px',
    default: '24px',
    large: '32px',
  };

  const fontSize = sizeMap[size];

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 100 100"
      className={className}
      style={{
        display: 'inline-block',
        fontSize,
        animation: 'v2-spin 1s linear infinite',
        ...style,
      }}
    >
      <style>
        {`
          @keyframes v2-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      {/* Outer arc */}
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke={primaryColor}
        strokeWidth="8"
        strokeDasharray="60 190"
        strokeLinecap="round"
      />
      {/* Inner arc */}
      <circle
        cx="50"
        cy="50"
        r="25"
        fill="none"
        stroke={secondaryColor}
        strokeWidth="6"
        strokeDasharray="40 120"
        strokeLinecap="round"
        style={{
          transformOrigin: '50% 50%',
          animation: 'v2-spin 1.5s linear infinite reverse',
        }}
      />
    </svg>
  );
};

export default V2Spinner;
